import React, { useState } from "react";
import { Alert, Box, Button, Typography } from "@mui/material";
import { mfa } from "../../utils/securityService";

/** On a staff member's page (Nov 2026): admins reset two-step sign-in when someone gets a new
 *  phone. The server checks the admin manages this person. */
const MfaResetPanel = ({ person }) => {
  const me = JSON.parse(localStorage.getItem("user") || "{}");
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);
  const isAdmin = ["disclosureAdmin", "districtAdmin", "schoolAdmin"].includes(me.permission);
  if (!isAdmin || !person?.id || person.id === me.id || person.type === "student") return null;

  const reset = async () => {
    if (!window.confirm(`Reset two-step sign-in for ${person.firstName || "this person"}? They'll set it up again next time they sign in.`)) return;
    setBusy(true);
    const res = await mfa({ action: "reset", userId: person.id }, { signedIn: true });
    setBusy(false);
    setMsg(res.ok ? { severity: "success", text: "Done. They'll set up two-step sign-in again at their next sign-in." }
                  : { severity: "error", text: res.message });
  };

  return (
    <Box sx={{ pl: "60px !important", pr: "60px !important", mt: 3, mb: 4 }}>
      <Box sx={{ border: "1px solid #ddd", borderRadius: "4px", p: 2 }}>
        <Typography sx={{ fontSize: 16, fontWeight: 700 }}>Two-step sign-in</Typography>
        <Typography sx={{ fontSize: 14, my: 1 }}>
          New phone or lost authenticator app? Reset it and they'll set it up again when they next sign in.
        </Typography>
        <Button variant="outlined" disabled={busy} onClick={reset} sx={{ textTransform: "none" }}>
          Reset two-step sign-in
        </Button>
        {msg && <Alert severity={msg.severity} sx={{ mt: 2 }}>{msg.text}</Alert>}
      </Box>
    </Box>
  );
};

export default MfaResetPanel;
